import { Http } from '@angular/http';
import { HttpClient, HttpHeaders, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Observer, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { environment } from './../../../environments/environment';
import { Router } from '@angular/router';
import { UtilsService } from './../../_services/utils.service';

@Injectable({
  providedIn: 'root'
})

export class DraftService {
  observer: Observer<number>;
  postMessageData: object;
  is_tournament: string;
  currentUser: any;
  user_id: number;
  drafters_id: string;
  league_id: number;

  constructor(private _http: Http, private http: HttpClient, private _utilsService: UtilsService,
    private router: Router) {  
    this.league_id = this.router.url.split('/')['5'];
    this.is_tournament = this.router.url.split('/')['6'];
    this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
    if (this.currentUser != null) {
      this.user_id = this.currentUser.id;
    }
  }

  getMessage(league_uuid, pageNo): Observable<any> {
    return this._utilsService.getRequest(`${environment.phpApiUrl}` + '/user_posts/get-draft-league-post/draft_user/' + league_uuid + '/all/' + pageNo, null, 'content-type-json');
  }

  getScore(league_type, ignorelist, early, late): Observable<any> {
    const scorePost = { 'access_token': 'draft_user', 'sport': league_type, 'start': early, 'end': late, 'excluded': ignorelist };
    return this._utilsService.postRequest(`${environment.phpApiUrl}` + '/scores/get-scores', scorePost, null, 'content-type-json');
  }

  getLeagueRecord(draft_id, uuid, is_tournament, round, draft_no): Observable<any> {
    if (is_tournament === `${environment.tournament}`) {
      return this._utilsService.getRequest(`${environment.phpApiUrl}` + '/tournament/get-lg-detail/draft_user/' + draft_id + '/' + uuid + '/' + round + '/' + draft_no);
    } else {
      return this._utilsService.getRequest(`${environment.phpApiUrl}` + '/fantasyLeague/get-detail/draft_user/' + draft_id + '/' + uuid);
    }
  }

  getSliderData(league_id): Observable<any> {
    const url = `${environment.draftUrl}` + '/getSlider/' + league_id;
    return this.http.get(url, {
        headers: new HttpHeaders({}),
        responseType : 'blob'
      })
      .pipe(
        map(res => res)
      );
  }

  getQueueData(lgm_id): Observable<any> {
    const url = `${environment.draftUrl}` + '/getQueue/' + lgm_id;
    return this.http.get(url, {
        headers: new HttpHeaders({}),
        responseType : 'blob'
      })
      .pipe(
        map(res => res)
      );
  }

  addToQueue(lgm_id, player_id): Observable<any> {
    return this._utilsService.getRequest(`${environment.draftUrl}` + '/addToQueue/' + lgm_id + '/' + player_id);
  }

  removeFromQueue(lgm_id, player_id): Observable<any> {
    return this._utilsService.getRequest(`${environment.draftUrl}` + '/removeFromQueue/' + lgm_id + '/' + player_id);
  }

  adjustQueue(lgm_id, isFirst, isLast, insertBefore, player_id): Observable<any> {
    return this._utilsService.getRequest(`${environment.draftUrl}` + '/adjustQueue/' + lgm_id + '/' + isFirst + '/' + isLast + '/' + ((insertBefore == null) ? 0 : insertBefore) + '/' + player_id);
  }

  getPlayerData(lg_id, game_id, season_id, event_type_id, myteam_id, page, egs, lgs, duration_id, league_status): Observable<any> {
    const url = `${environment.boxScoreUrl}/getPlayers/${lg_id}/${game_id}/${season_id}/${event_type_id}/${myteam_id}/${page}/${egs}/${lgs}/${duration_id}/${league_status}`;
    return this.http.get(url, {
        headers: new HttpHeaders({}),
        responseType : 'blob'
      })
      .pipe(
        map(res => res)
      );
  }

  getDraftData2(league_id, user_id): Observable<any> {
    return this._utilsService.getRequest(`${environment.boxScoreUrl}` + '/getDraftData2/' + league_id + '/' + user_id);
  }

  getPlayerTable(lg_id, game_id, season_id, event_type_id, myteam_id, page, egs, lgs, duration_id): Observable<any> {
    let url = '';
    if (duration_id == 5) {
      url = `${environment.phpApiUrl}/league/playoffPlayer/${environment.DRAFT_ACCESS_TOKEN}/${lg_id}/${game_id}/${season_id}/${event_type_id}/${myteam_id}/${page}`;
    } else if (duration_id == 8) {
      url = `${environment.phpApiUrl}/league/bestBallPlayer/${environment.DRAFT_ACCESS_TOKEN}/${lg_id}/${game_id}/${season_id}/${event_type_id}/${myteam_id}/${page}`;
    } else {
      url = `${environment.phpApiUrl}/league/players/${environment.DRAFT_ACCESS_TOKEN}/${lg_id}/${egs}/${lgs}/${game_id}/${myteam_id}/${page}`;
    }
    return this._utilsService.getRequest(url);
  }


  getLeaguePlayers(draft_id): Observable<any> {
    return this._utilsService.getRequest(`${environment.phpApiUrl}` + '/league-member/get-list/draft_user/' + draft_id);
  }

  createObservable(): Observable<number> {
    return new Observable<number>(observer => {
      this.observer = observer;
    });
  }

  unfollowMember(user_id, league_id): Observable<any> {
    const scorePost = { 'access_token': 'draft_user', 'user_id': user_id, 'league_id': league_id };
    return this._utilsService.postRequest(`${environment.phpApiUrl}` + '/league-member/unfollow', scorePost, null, 'content-type-json');
  }

  getTournamentGroupRound(tournament_id, round_id): Observable<any> {
    return this._utilsService.getRequest(`${environment.phpApiUrl}` + '/tournaments/get-group-rounds/draft_user/' + tournament_id + '/' + round_id);
  }

  checkDraftAgain(league_id, user_id): Observable<any> {
    return this._utilsService.getRequest(`${environment.boxScoreUrl}` + '/checkDraftAgain/' + league_id + '/' + user_id);
  }

  getTeamListForSlider(team_id): Observable<any> {
    return this._utilsService.getRequest(`${environment.phpApiUrl}` + '/players/draft_player_list/' + `${environment.DRAFT_ACCESS_TOKEN}` + '/' + team_id);
  }

  // remove data from local storage
  removePlayerData(pkey) {
    let plyData = JSON.parse(localStorage.getItem('player_data'));
    if (plyData != null) {
      let index = plyData.findIndex(x => x.key == pkey);
      if (index > -1) {
        plyData.splice(index, 1);
        localStorage.setItem('player_data', JSON.stringify(plyData));
      }
    }
  }

  errorLog(data): Observable<any> {
    return this._utilsService.postRequest(`${environment.phpApiUrl}` + '/user/angular-error-log', data);
  }

  getPositionBG(position) {
    const colors = {
      'QB': '#bac9e2',
      'RB': '#bae2ba',
      'WR': '#e2e1ba',
      'TE': '#e2baba',
      'DEF': '#bae2e0',
      'K': '#d8bae2',
      'FLEX': 'rgba(146, 134, 44, 0.60)',
      'C': 'rgba(207, 93, 41, 0.30)',
      'LW': 'rgba(72, 175, 23, 0.30)',
      'RW': 'rgba(207, 189, 22, 0.30)',
      'D': 'rgba(71, 170, 162, 0.30)',
      'G': 'rgba(189, 23, 23, 0.30)',
      '1B': 'rgba(84, 45, 224, 0.30)',
      '2B': 'rgba(72, 179, 23, 0.30)',
      '3B': 'rgba(207, 189, 22, 0.30)',
      'SS': 'rgba(223, 27, 27, 0.30)',
      'LF': 'rgba(32, 180, 155, 0.30)',
      'CF': 'rgba(155, 32, 167, 0.30)',
      'RF': 'rgba(187, 38, 120, 0.30)',
      'SP': 'rgba(76, 153, 147, 0.30)',
      'TG': 'rgba(74, 79, 136, 0.30)',
      'BN': 'rgba(58, 131, 119, 0.30)',
      'IR': 'rgba(51, 109, 63, 0.30)',
      'W': 'rgba(167, 94, 46, 0.30)',
      'F': 'rgba(150, 56, 90, 0.30)',
      'S': 'rgba(54, 131, 33, 0.30)',
      'MI': 'rgba(60, 82, 54, 0.30)',
      'OF': 'rgba(148, 77, 139, 0.30)',
      'DH': 'rgba(97, 42, 56, 0.30)',
      'UTIL': 'rgba(70, 148, 148, 0.30)',
      'P': 'rgba(101, 131, 76, 0.30)',
      'RP': 'rgba(120, 155, 39, 0.30)',
      'PG': 'rgba(136, 34, 34, 0.30)',
      'FG': 'rgba(104, 134, 28, 0.30)',
      'SG': '#8ae06b',
      'SF': 'rgba(37, 50, 172, 0.30)',
      'PF': 'rgba(106, 39, 131, 0.30)',
      'IF': 'rgba(52, 235, 235, 0.30)',
      'WR-TE': 'rgba(255, 118, 20, 0.50)',
      'SFLEX': 'rgba(179, 162, 211, 0.50)',
      'default': '#ddd'
    };
    if (typeof colors[position] !== 'undefined') {
      return colors[position];
    } else {
      return 'rgba(173, 188, 230, 0.50)';
    }
  }

  private handleError(error) {
    console.error('server error: ', error);
    if (error.error instanceof Error) {
      const errMessage = error.error.message;
      return Observable.throw(errMessage);
    }
    return Observable.throw(error || 'Socket.io server error');
  }

  private handleErrorPost<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      // TODO: send the error to remote logging infrastructure
      console.error(result); // log to console instead 
      // TODO: better job of transforming error for user consumption
      console.log(`${operation} failed: ${error.message}`);
      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

}
